import gql from 'graphql-tag';

import type { GenerationTool } from 'src/data/generationTool';
import type { ShortFormContentType } from 'src/data/shortForm';
import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const QUERY = gql`
  query ShortFormToolsForContentType($contentType: ShortFormContentTypeEnum!) {
    shortFormToolsForContentType(contentType: $contentType) {
      generationTool
    }
  }
`;

interface Options {
  abortSignal?: AbortSignal;
}

interface Result {
  generationTool: GenerationTool;
}

export const queryLongFormToolsForContentType = async (
  contentType: ShortFormContentType,
  options?: Options
) => {
  const variables = {
    contentType,
  };

  const response = await executeGqlQuery({
    query: QUERY,
    variables,
    options: {
      abortSignal: options?.abortSignal,
    },
  });
  return getSingleProp<Result>(response.data);
};
